/**----------------------------------   Submit Action   ------------------------------------*/
export const SubmitCycleActionType = {
	APPROVE: 1,
	REJECT: 2,
	ALERT: 3,
} as const;

export type SubmitCycleActionType = (typeof SubmitCycleActionType)[keyof typeof SubmitCycleActionType];
